module.exports = __webpack_public_path__ + "static/img/bean_500.6732d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bean_500.png
// module id = gUhT
// module chunks = 2